import React, {useEffect, useState} from 'react';
import Swal from 'sweetalert2';
import {getLanguage, t} from 'react-switch-lang';
import {Edit} from '../../../components/modals/ModalEdit';
import {Delete} from '../../../components/modals/ModalDelete';
import {Show} from '../../../components/modals/ModalShow';
import SearchHeader from '../department/pageHeader/PageHeader';
import {Add} from '../../../components/modals/ModalAdd';
import Loader from '../../../components/loader/Loader';
import TableAdministration from '../../../components/tablesAdministration/Table-administration';
import {
  getAllExternalizationDocumentTemplates, downloadExternalizationFile
} from '../../../services/externalizations/externalizationTemplatesServices';
import DownloadOutlined from "@ant-design/icons/lib/icons/DownloadOutlined";
import './ExternalizationTemplates.scss';
import {searchExternalizationTemplates} from '../../../utils/externalizationFormOptions';
import roles from '../../../utils/roles';
import {useUserContext} from '../../../contexts/UserContext';

const ExternalizationTemplates = () => {

  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState('');
  const [rowChanged, setRowChanged] = useState(false);
  const [search, setSearch] = useState('');
  const [tableKey, setTableKey] = useState(0);
  const [allowActions, setAllowActions] = useState(false);
  const user = useUserContext()

  const allowedRoles = [
    roles.role_admin,
    roles.role_super_admin,
    roles.role_risk_sector
  ];
  useEffect(() => {
    const result = allowedRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    setAllowActions(result?.length > 0);
  }, [user]);
  const fetchData = () => {

    setIsLoading(true);
    setIsLoadingPage(true);

    getAllExternalizationDocumentTemplates()
      .then((r) => {
        setItems(generateRows(r.data));
        setFilterItems(generateRows(r.data));
        setIsLoading(false);
        setIsLoadingPage(false);
      })
      .catch((r) => {
        setIsLoading(false);
        setIsLoadingPage(false);
        if (r.message === 'Network Error') {
          Swal.fire({
            text: `${t('message.errorServerTitle')}`,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        } else {
          Swal.fire({
            text: `${t('message.errorApi')}`,
            icon: 'error',
            confirmButtonText: 'Ok',
          });
        }
      });

  };
  const generateRows = (items) => {
    return items.map(item => {
       return {
          name: item.name,
          nameEn: item.nameEn,
           template: <span
               onClick={(e) => {
                   e.stopPropagation()
               downloadExternalizationFile(item?.template?.id, item?.template?.fileName);
            }}
               className={'d-flex downloadBtn'}>{item?.template?.fileName}
               <DownloadOutlined
               className={'ml-3'}
           />
          </span>,
          onClick: () => onRowClick(item),
          buttons: [
            allowActions && <Edit data={item} id='externalizationsTemplates'
                  setRowChanged={() => onRowChange()} fetchData={() => fetchData()} />
            ,
            allowActions && <Delete
              data={item}
              id='externalizationsTemplates'
              setRowChanged={() => onRowChange()}
            />,

          ],
        };
      },
    );
  };
  const filterList = (event) => {
    const search = event.target.value;
    setSearch(search);
    setFilterItems(searchExternalizationTemplates(search, items));
  };
  useEffect(() => {
    fetchData();
  }, [rowChanged]);

  const onRowClick = (item) => {
    setModalData(item);
    setModal(!modal + 1);
  };

  const onRowChange = () => {
    setRowChanged(!rowChanged);
    setSearch('');
    setTableKey(tableKey + 1);
  };
  const tableHeader = [
    t('externalization.name'),
    t('externalization.nameEn'),
    t('externalization.riskProponentForm.file')
  ];

  return (
    <div style={{padding: '0 30px'}} className=' h-100  pb-3'>

      <Show
        data={modalData}
        id='externalizationsTemplates'
        type='externalizationsTemplates'
        modal={modal}
        setModal={setModal}
        isEditable={true}
        setRowChanged={() => onRowChange()}
        fetchData={() => fetchData()}
      />
      <SearchHeader
        placeholder={t('externalization.riskProponentForm.placeholder.search')}
        button={allowActions && <Add id='externalizationsTemplates' setRowChanged={() => onRowChange()} />}
        onChange={(e) => filterList(e)}
        showInput={true}
        showButton={true}
      />
      <div
        className='position-relative administration-page-table-container pt-4'>
        {isLoadingPage && <Loader zIndex={'1'} />}
        <TableAdministration
          key={tableKey}
          tableHeader={tableHeader}
          tableRows={search ? filterItems : items}
          hasMore={false}
          isLoading={isLoading}
          editableRow={false}
        />
      </div>

    </div>
  );
};

export default ExternalizationTemplates;